<template>
  <div class="d-flex">
    <template v-if="showMenuReportWithRec && isAllowedMenu">
      <v-menu v-model="menuOpen" offset-y min-width="212px" :close-on-content-click="true">
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="primary" outlined class="d-flex align-center" v-bind="attrs" v-on="on" :loading="loading">
            <span class="mr-2">Скачать PDF-отчет</span>
            <v-icon>mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-for="item in menuItems" :key="item.id" @click="onSelectFromMenu(item.id)">
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

    </template>
    <v-btn v-else color="primary" outlined @click="onDownload" :loading="loading" style="width: 207px"> Скачать PDF-отчет </v-btn>

    <v-menu v-if="$store.getters['auth/isAllowed']('download_without_logo')" offset-y min-width="212px" left :nudge-top="0" :close-on-content-click="false">
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="primary" outlined class="px-0 icon drop-down-btn" v-bind="attrs" v-on="on">
          <v-icon dark>mdi-chevron-down</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item>
          <v-checkbox v-model="removeLogo" label="Убрать логотип"></v-checkbox>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  props: {
    loading: Boolean,
    showMenuReportWithRec: Boolean,
  },
  data() {
    return {
      removeLogo: false,
      menuItems: [
        { id: 'candidate', title: 'Скачать с рекомендациями для кандидата' },
        { id: 'manager', title: 'Скачать с рекомендациями для руководителя' }
      ],
      menuOpen: false
    };
  },
  computed: {
    isAllowedMenu() {
      // return 1;
      return this.$store.getters['auth/isAllowed']('can_download_constructor_candidate_report');
    }
  },
  methods: {
    onDownload() {
      this.$emit('downloadPdf', { logo: !this.removeLogo });
    },
    onSelectFromMenu(id) {
      this.menuOpen = false;
      this.$emit('downloadPdf', { typeReco: id, logo: !this.removeLogo });
    }

  }
};
</script>

<style scoped>
.drop-down-btn {
  min-width: 40px !important;
  color: white !important;
}
</style>
